
<header id="top-bar">
  <nav class="navbar navbar-expand">
    <a class="burger-btn d-block nav-toggler">
      <img class="nav-toggler" src="assets/icons/menu_black_24dp.svg">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
      aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="project dropdown" ngbDropdown>
      <span class="projectTitle">{{'topBar.project' | translate }}</span>
      <a href="javascript:void(0)" id="projectDropdownMenuButton" ngbDropdownToggle>
        <div class="project-menu ">
          <span class="projectName" id="currentProject">{{currentProjectName}}</span>
        </div>
      </a>
      <ul class="project-dropdown dropdown-menu dropdown-menu-end project-select" ngbDropdownMenu aria-labelledby="projectDropdownMenuButton">
        @for (item of projects | keyvalue; track item.key) {
          <li id="dropdownMenuItems">
            <button [ngStyle]="currentProjectId == item.key ? { 'background-color': '#F4F7FC', 'color': '#0058FF' } : {}"
            class="dropdown-item" ngbDropdownItem (click)="switchProject(item.key)">{{item.value}}</button>
          </li>
        }
      </ul>
    </div>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
      </ul>
      <div class="dropdown" ngbDropdown>
        <a href="javascript:void(0)" id="dropdownMenuButton" ngbDropdownToggle>
          <div class="user-menu d-flex circle">
            <div class="user-name initials">
              <h6 class="mb-0">{{ initials }}</h6>
            </div>
            <div class="user-img d-flex align-items-center">
              <div class="avatar avatar-md">
              </div>
            </div>
          </div>
        </a>
        <ul class="user-dropdown dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <li>
            <h6 class="dropdown-header">{{'topBar.hello' | translate}}, {{ firstName }}!</h6>
          </li>
          <li>
            <button class="dropdown-item" ngbDropdownItem>
              <i class="icon-mid bi bi-person me-2"></i>
              {{'topBar.profile' | translate }}
            </button>
          </li>
          <li>
            <button class="dropdown-item" ngbDropdownItem>
              <i class="icon-mid bi bi-gear me-2"></i>
              {{'basic.settings' | translate }}
            </button>
          </li>
          <li>
            <hr class="dropdown-divider">
          </li>
          <li>
            <button id="logout-button" (click)="logout()" class="dropdown-item" ngbDropdownItem>
              <i class="icon-mid bi bi-box-arrow-left me-2"></i>
              {{'basic.logOut' | translate }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>
